import { formatCurrency } from './formatCurrency';

// Entries come from the API's `credited_via` ([{tag, won, pipeline}]); `measure` picks the dollar field.
export function creditedViaParts(entries, measure = 'won') {
  return (entries || [])
    .filter(e => (e[measure] ?? 0) > 0)
    .map(e => `${e.tag} ${formatCurrency(e[measure])}`);
}

export function creditedViaText(entries, measure = 'won', limit = 3) {
  const parts = creditedViaParts(entries, measure);
  if (!parts.length) return '';
  const shown = parts.slice(0, limit).join(' · ');
  return parts.length > limit ? `${shown} +${parts.length - limit} more` : shown;
}
